import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/_organization/ndis-standards/complaints/$complaintId'
)({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/compliance/complaints/$complaintId', params, replace: true })
  },
  component: () => null,
})
